export default {
  name: 'CustomHorizontalList',
  displayName: {
    en: 'Custom Horizontal List',
    ja: '水平リスト',
  },
  // icon: './icon.png',
  // defaultWidth: 155,
  // defaultHeight: 44,
  resizeX: true,
  props: [
    {
      name: 'items',
      displayName: {
        en: 'What is this a list of?',
        ja: 'データベースの選択',
      },
      type: 'list',
    },
    {
      name: 'sortList',
      displayName: {
        en: 'Sorting',
        ja: '並び替え',
      },
      type: 'sort',
    },
    {
      name: 'maximumItems',
      displayName: {
        en: 'Maximum number of items',
        ja: '上限',
      },
      type: 'maximumItems',
    },

    {
      name: 'onPress',
      displayName: {
        en: 'List',
        ja: 'リスト',
      },
      type: 'action',
      role: 'listItem',
      reference: 'items',
    },
  ],
  childComponents: [
    {
      displayName: {
        en: 'Image',
        ja: '画像',
      },
      name: 'cardCover',
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'image',
          displayName: {
            en: 'Image Source',
            ja: '画像ソース',
          },
          type: 'image',
        },
      ],
    },
    {
      name: 'tag',
      displayName: {
        en: 'Tag',
        ja: 'タグ',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          default: 'SOLD OUT',
          name: 'text',
          displayName: {
            en: 'Text',
            ja: 'テキスト',
          },
          type: 'text',
          styles: {
            fontFamily: '@body',
            fontWeight: '600',
          },
        },
        {
          name: 'filter',
          displayName: {
            en: 'Will be visible only when...',
            ja: '以下の条件で表示',
          },
          type: 'filter',
        },
        {
          name: 'disableClick',
          displayName: {
            ja: 'できなくする',
            en: 'Disable Click',
          },
          type: 'switch',
          default: 'true',
        },
      ],
    },
    {
      name: 'title',
      displayName: {
        en: 'Title',
        ja: 'タイトル',
      },
      role: 'listItem',
      reference: 'items',
      props: [
        {
          default: '0000円',
          name: 'text',
          displayName: {
            en: 'Price',
            ja: '価格',
          },
          type: 'text',
          styles: {
            fontFamily: '@body',
            color: '@text',
            fontWeight: '500',
            fontSize: '20',
            textAlignment: 'left',
          },
        },
        {
          name: 'enabled',
          type: 'boolean',
          default: 'true',
        },
        {
          name: 'titleLineNum',
          displayName: {
            en: 'Number of Lines',
            ja: '行数',
          },
          type: 'number',
          default: 1,
          control: {
            type: 'menu',
            options: [
              {
                label: 'canvas.menuRight.elementTab.list.singleLine',
                value: 1,
              },
              {
                label: 'canvas.menuRight.elementTab.list.doubleLine',
                value: 2,
              },
            ],
          },
        },
      ],
    },
  ],
};
